import axios from "axios";

export enum ClaimStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

export type SimpleClaimResponse = {
  claim: ClaimResponse;
};

export type ClaimResponse = {
  id: string;
  restaurantId: string;
  status: ClaimStatus;
  phoneNumber: string;
  email: string;
  suppliers: string[];
  company: string;
  firstName: string;
  lastName: string;
  creationDate: Date;
};

export type FetchClaimOptions = {
  id: string;
};

export type ClaimCheckTokenResponse = {
  message: string;
  code: string;
  redirectUrl: string;
};

export type ClaimApproveRejectWithTokenResponse = {
  message: string;
  code: string;
  redirectUrl: string;
};
export type ClaimApproveRejectResponse = {
  message: string;
  code: string;
};


export type ClaimRestaurantResponse = {
  message: string;
  code: string;
};

export type AskClaimRestaurantParams = {
  email: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
  suppliers: string[];
  company: string;
};


export const fetchClaimsByOwnerRequest = async (): Promise<ClaimResponse[]> => {
  const { data } = await axios.get<{ claims: ClaimResponse[] }>('/protected/claims/owner');
  return Array.isArray(data.claims) ? data.claims : [];
};

export const fetchClaimRequest = async (id: string): Promise<ClaimResponse> => {
  const { data } = await axios.get<ClaimResponse>(`/protected/claim/${id}`);
  return data;
};

export const checkClaimTokenRequest = async (token: string): Promise<ClaimCheckTokenResponse> => {
  const { data } = await axios.post(`/claim/${token}/check`);
  return data;
}


export const askRestaurantClaimRequest = async (restaurantId: string, params: AskClaimRestaurantParams): Promise<ClaimRestaurantResponse> => {
  const { data } = await axios.post(`/claim/${restaurantId}/ask`, params);
  return data;
}

export const approveClaimRequestWithToken = async (token: string): Promise<ClaimApproveRejectWithTokenResponse> => {
  const { data } = await axios.post(`/claim/${token}/approve`);
  return data;
}

export const approveClaimRequest = async (claimId: string): Promise<ClaimApproveRejectResponse> => {
  const { data } = await axios.post(`/protected/claim/${claimId}/approve`);
  return data;
}

export const rejectClaimRequestWithToken = async (token: string): Promise<ClaimApproveRejectWithTokenResponse> => {
  const { data } = await axios.post(`/claim/${token}/reject`);
  return data;
}

export const rejectClaimRequest = async (claimId: string): Promise<ClaimApproveRejectResponse> => {
  const { data } = await axios.post(`/protected/claim/${claimId}/reject`);
  return data;
}